import { Redirect, Stack, useLocalSearchParams } from 'expo-router';
import { ActivityIndicator, View } from 'react-native';

import { AdminModeHeader } from '@/components/admin-mode-header';
import { useTenant } from '@/components/tenant-provider';
import { IntegrationSettingsScreen } from '@/components/integrations/integration-settings-screen';
import { Card, CardContent } from '@sixam/ui/card';
import { Text } from '@sixam/ui/text';
import { useTenantOwnerAccess } from '@/lib/use-tenant-owner-access';

export default function TenantSettingsIntegrationsScreen() {
  const { tenant } = useLocalSearchParams<{ tenant: string }>();
  const { activeTenant } = useTenant();
  const ownerAccess = useTenantOwnerAccess();
  const tenantId = activeTenant?.id;

  if (ownerAccess.isLoading) {
    return (
      <>
        <Stack.Screen
          options={{ headerShown: process.env.EXPO_OS !== 'web', title: 'Integrations' }}
        />
        <Stack.Screen.BackButton displayMode="minimal">Club</Stack.Screen.BackButton>
        <View className="flex-1 items-center justify-center bg-background">
          <ActivityIndicator />
        </View>
      </>
    );
  }

  if (!ownerAccess.isAllowed) {
    return <Redirect href={{ pathname: '/admin/[tenant]', params: { tenant } }} />;
  }

  if (!tenantId) {
    return (
      <>
        <Stack.Screen
          options={{ headerShown: process.env.EXPO_OS !== 'web', title: 'Integrations' }}
        />
        <Stack.Screen.BackButton displayMode="minimal">Club</Stack.Screen.BackButton>
        <Card>
          <CardContent className="pt-6">
            <Text variant="muted">No active tenant.</Text>
          </CardContent>
        </Card>
      </>
    );
  }

  return (
    <>
      <Stack.Screen
        options={{ headerShown: process.env.EXPO_OS !== 'web', title: 'Integrations' }}
      />
      <Stack.Screen.BackButton displayMode="minimal">Club</Stack.Screen.BackButton>
      <IntegrationSettingsScreen
        ownerType="tenant"
        ownerQuery={`tenant_id=${encodeURIComponent(tenantId)}`}
        returnBasePath={`/admin/${tenant}/settings/integrations`}
        header={
          process.env.EXPO_OS === 'web' ? (
            <AdminModeHeader title="Integrations" subtitle={activeTenant?.name} />
          ) : (
            <Text variant="muted">{activeTenant?.name}</Text>
          )
        }
        title="Integrations"
        subtitle={activeTenant?.name ?? 'Tenant accounts'}
      />
    </>
  );
}
